<template>
  <base-page-template>
    <template #toolbar-items>
      <el-tooltip content="確定" placement="bottom">
        <v-btn icon color="green" :disabled="!dirty || !valid" @click="doSave">
          <v-icon>mdi-check-bold</v-icon>
        </v-btn>
      </el-tooltip>
      <v-toolbar-title class="with-divider">
        外部辞書トークン一覧
      </v-toolbar-title>
    </template>

    <v-form v-model="valid">
      <el-table
          :data="tokensFilteredView">
        <el-table-column
            label="ID"
            width="120"
            column-key="token/id">
          <template #default="{row}">
            <table-inline>
              <hds-id-field :value="row.dictionary.id"></hds-id-field>
            </table-inline>
          </template>
        </el-table-column>
        <el-table-column
            label="辞書名"
            min-width="30"
            column-key="name-alt">
          <template #default="{row}">
            <table-inline>
              <v-text-field
                  v-model="row.dictionaryNameAlt"
                  :rules="[v => !!v || '辞書名を入力してください']"
                  @input="updateToken(row)">
                <template #prepend-inner>
                  <dictionary-icon :type="row.dictionary.dictionaryType"></dictionary-icon>
                </template>
              </v-text-field>
            </table-inline>
          </template>
        </el-table-column>
        <el-table-column
            label="説明"
            min-width="40"
            column-key="description-alt">
          <template #default="{row}">
            <table-inline>
              <description-input
                v-model="row.dictionaryDescriptionAlt"
                @input="updateToken(row)">
              </description-input>
            </table-inline>
          </template>
        </el-table-column>
        <el-table-column
            label="個別辞書名"
            min-width="30"
            prop="dictionary.name">
        </el-table-column>
        <el-table-column
            label="個別辞書登録日"
            width="150"
            column-key="dictionary.createdAt">
          <template #default="{row}">
            {{ formatDate(row.dictionary.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column
            label="ステータス"
            width="100"
            align="center"
            column-key="status">
          <template #default="{row}">
            {{ row.importedCount ? '利用中' : '未利用' }}
          </template>
        </el-table-column>
        <el-table-column
            width="70"
            align="right"
            fixed="right">
          <template #default="{row}">
            <icon-btns>
              <icon-btn
                  type="view"
                  :to="{name: '/browse/external/dictionary/Dictionary', params: {dictionaryId: row.dictionary.id}}">
              </icon-btn>
            </icon-btns>
          </template>
        </el-table-column>
      </el-table>
    </v-form>
  </base-page-template>
</template>

<script>
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import IoablePageMixin from "@/router/IoablePageMixin";
import {mapActions, mapGetters, mapMutations} from "vuex";
import gql from "graphql-tag";
import TableInline from "@/components/atoms/TableInline.vue";
import DescriptionInput from "@/components/molecules/DescriptionInput.vue";
import Formatter from "@/utils/Formatter";
import HdsIdField from "@/components/molecules/HdsIdField.vue";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import DictionaryIcon from "@/components/molecules/DictionaryIcon.vue";
export default {
  name: "Tokens",
  components: {DictionaryIcon, IconBtn, IconBtns, HdsIdField, DescriptionInput, TableInline, BasePageTemplate},
  mixins: [IoablePageMixin, Formatter],
  data() {
    return {
      dirty: false,
      valid: true,
      tokens: [],
    };
  },
  computed: {
    ...mapGetters({
      hdsEntities: 'hds/entities',
    }),
    tokensView() {
      return this.hdsEntities.dictionaryToken.find();
    },
    tokensFilteredView() {
      return this.tokensView.filter(token => token.dictionary.dictionaryType !== 'common');
    }
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    ...mapActions({
      gqlQueryAndLoad: 'hds/gqlQueryAndLoad',
      gqlMutate: 'hds/gqlMutate',
    }),
    async load() {
      await this.gqlQueryAndLoad({
        clear: true,
        query: gql`
          query Tokens {
              tokens: dictionaryTokens {
                token
                dictionaryNameAlt
                dictionaryDescriptionAlt
                dictionary {
                    id
                    name
                    dictionaryType
                    createdAt
                }
                importedCount
              }
          }`,
        mapping: {
          dictionaryToken: 'tokens'
        }
      });
    },
    async save() {
      const delta = this.hdsEntities.dictionaryToken.getDelta({
        update: ['token', 'dictionaryNameAlt', 'dictionaryDescriptionAlt']
      });

      await this.gqlMutate({
        mutation: gql`
          mutation Tokens(
            $dictionaryTokens: [DictionaryTokenUpdateInput!]!
          ) {
              updateDictionaryTokens(dictionaryTokens: $dictionaryTokens)
          }`,
        variables: {
          dictionaryTokens: delta.update,
        }
      });
    },
    updateToken(token) {
      this.hdsEntities.dictionaryToken.update(token);
      this.markDirty();
    }
  }
}
</script>

<style scoped>

</style>
